const CreateEvent_mutate = `
  mutation createEvent(
    $periodId: Int!
    $eventTypeId: Int!
    $name: String!
    $desc: String 
    $scheduledDate: String!
    $actualDate: String
    $attendanceRequired: Boolean!
  ) {
    createEvent(
      periodId: $periodId,
      eventTypeId: $eventTypeId,
      name: $name,
      desc: $desc,
      scheduledDate: $scheduledDate,
      actualDate: $actualDate,
      attendanceRequired: $attendanceRequired,
    ) {
      event
        {
          eventId
          name
          desc
          attendanceRequired
          periodId            
          {
            periodId
          }
          eventTypeId            
          {
            eventTypeId
            name
          }
          createBy
          createDate
          updateBy
          updateDate
        }
      }
    }
`;

const EditEvent_mutate = `
  mutation editEvent(
    $eventId:Int!
    $eventTypeId: Int
    $name: String
    $desc: String
    $scheduledDate: String
    $actualDate: String
    $attendanceRequired: Boolean
  ){
    editEvent(
      eventId: $eventId,
      eventTypeId: $eventTypeId,
      name: $name,
      desc: $desc,
      scheduledDate: $scheduledDate,
      actualDate: $actualDate,
      attendanceRequired: $attendanceRequired
    ){
      event{
        eventId
        name
        desc
        scheduledDate
        actualDate
        attendanceRequired
      }
    }
  }
`;  

const DeleteEvent_mutate = `
    mutation deleteEvent($eventId: Int!) {
      deleteEvent(eventId: $eventId) {
        response
      }
    }
`;

module.exports = {  
  CREATE_EVENT_MUTATION: CreateEvent_mutate,
  EDIT_EVENT_MUTATION: EditEvent_mutate,
  DELETE_EVENT_MUTATION: DeleteEvent_mutate,
}
